import React from 'react'
import { Link } from 'react-router-dom';
import Logisticssubscriptiondata from "./Logisticssubscriptiondata";
import LogisticsBannerspage from "./LogisticsBannerspage";
import LogisticsAboutsubscription from "./LogisticsAboutsubscription";
// import "./foodsubscription.css";

const Logisticssubscription = () => {
    return (
        <div style={{
            marginTop: "102px", 
            overflow: "auto", 
            scrollbarWidth: "none"
        }} className='subscription-scrolling-data-mobile-view'>
            <p
                className="breadcrumb maamaas-home-bredcum or7"
                style={{
                    position: "fixed",
                    top: "40px",
                    left: "1vw",
                    width: "100%",
                    backgroundColor: "#fff",
                    padding: "30px 0",
                    fontSize: "18px",
                    fontWeight: "bold",
                    textAlign: "center",
                    margin: 0,
                    height: "42px",
                    zIndex: 999,
                }}
            >
                <Link
                    to="/Homes"
                    style={{
                        color: "purple",
                        fontWeight: "bold",
                        textDecoration: "none",
                    }}
                >
                    Home
                </Link>
                <span className="separator"> &gt; </span>
                <span
                    style={{
                        color: "purple",
                        fontWeight: "bold",
                        textDecoration: "none",
                    }}
                >
                    Subscription_Managment
                </span>
                <span className="separator"> &gt; </span>
                <span
                    style={{
                        color: "purple",
                        fontWeight: "bold",
                        textDecoration: "none",
                    }}
                >
                    Logistics & Supply
                </span>
            </p>
            <div style={{ height: "400px" }} className='banners-subscription-data-page'>
                <LogisticsBannerspage />
                <LogisticsAboutsubscription />
                <Logisticssubscriptiondata />
            </div>
        </div>
    )
}

export default Logisticssubscription